import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const SystemPage = lazy(() => import('./SystemPage'));

export const systemRoutes: RouteObject[] = [
  {
    path: 'system',
    element: (
      <ProtectedRoute action="system:view">
        <SystemPage />
      </ProtectedRoute>
    ),
  },
];
